import * as InitialsApartmentsActions from "./apartment.actions";

import {createEntityAdapter, EntityAdapter} from "@ngrx/entity";
import {createReducer, on} from "@ngrx/store";
import {StoredComponentHelperService} from '@common/helpers/stored-component.helper.service';
import {InitialsApartmentDocument} from '@accounting/_common/models/accounting-initials.models';
import {EntityStateModel} from '@common/models/entity-state.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const initialsApartmentFeatureKey = 'initialsApartment';

export function sortEntities(a: InitialsApartmentDocument, b: InitialsApartmentDocument) {
    return b.date!.localeCompare(a.date!);
}

export const adapter: EntityAdapter<InitialsApartmentDocument> = createEntityAdapter<InitialsApartmentDocument>({
    sortComparer: sortEntities
});


export type InitialsApartmentState = EntityStateModel<InitialsApartmentDocument, any>;

export const initialState: InitialsApartmentState = adapter.getInitialState({
    listLoading: 'listLoading',
    pagination: {},
    itemsLoading: []
});

export const initialsApartmentReducer = createReducer(
    initialState,

    on(InitialsApartmentsActions.LoadList, (state, action) => ({
        ...state,
        listLoading: StoredComponentHelperService.updateListLoading(action.payload, state.ids)
    })),

    on(InitialsApartmentsActions.LoadListSuccess, (state, action) => {
        return adapter.setAll(action.payload.items, {
            ...state,
            pagination: action.payload.pagination,
            listLoading: undefined
        });
    }),

    on(InitialsApartmentsActions.LoadListFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(InitialsApartmentsActions.SetLoading, (state, action) => ({
        ...state,
        listLoading: action.payload
    })),

    on(InitialsApartmentsActions.SetItemsLoading, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id, action.payload.isStart)
    })),

    on(InitialsApartmentsActions.UpdateItemSuccess, (state, action) => {
        return adapter.setOne(action.payload!, {
            ...state,
            itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, false),
            pagination: {...state.pagination, totalElements: StoredComponentHelperService.setTotalElements(action.payload.id!, state.pagination, state?.ids)}
        });
    }),

    on(InitialsApartmentsActions.DeleteItem, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, true)
    })),

    on(InitialsApartmentsActions.DeleteItemSuccess, (state, action) => {
        return adapter.removeOne(action.payload.id!, {
            ...state,
            itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, false),
            pagination: {...state.pagination, totalElements: StoredComponentHelperService.setTotalElements(action.payload.id!, state.pagination, state?.ids, true)}
        });
    }),

    on(InitialsApartmentsActions.DeleteItemFailure, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id!, false)
    })),

    on(InitialsApartmentsActions.SetInitialState, SetAllInitialStates, () => ({...initialState}))
);

export const {selectAll: selectAllEntities} = adapter.getSelectors();
